import Swiper from 'swiper';

class Slider {
    constructor() {

        /* Si existe primer slider del Menu */
        if (document.getElementsByClassName("swiper-menu")[0])
        this.swiperMenu();

        /* Si existe primer slider del Home */
        if (document.getElementsByClassName("swiper-video")[0])
            this.swiperVideo();

        /* Si existe el slider del modal ver fotos en detalle departamento */
        if (document.getElementsByClassName("swpr-inter")[0])
            this.galeriaInteriores = this.swiperInteriores();

             /* Si existe el slider del modal ver fotos en detalle departamento */
        if (document.getElementsByClassName("swpr-inter")[0])
        this.galeriaInteriores = this.swiperInformation();

            

        /* Si existe el slider galeria de amenidades del detalle deptos */
        if (document.getElementsByClassName("gallery-top")[0])
            this.galeriaAmenidades = this.swiperAmenidades();
        /* Si existe el slider galeria de amenidades del detalle deptos */
        if (document.getElementsByClassName("gallery-top")[0])
        this.galeriaAmenidades = this.swiperAmenidadesddos();

        /* Slider deptos que podrian gustarte en detalle departamento */
        if (document.getElementsByClassName("siliderDpt")[0]){
            this.masDpt = this.siliderDpt();
            /* oculta flecas si son menos de 3 */
            if (document.getElementsByClassName("swiper-count-slide").length <= 3) {
                let btnCont = document.getElementsByClassName("btn-cont");
                Array.prototype.forEach.call(btnCont, (_el) => {
                    _el.style.display = "none";
                })
            }
        }
    }

    /***************************/
    /* primer slider Menu */
    /***************************/
    swiperMenu() {
        new Swiper(".swiper-menu", {
            observer: true,
            observeParents: true,
            pagination: {
                el: '.swiper-pagination-menu',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next-menu',
                prevEl: '.swiper-button-prev-menu',
            },
        });
    }

    /***************************/
    /* Slider del Home */
    /***************************/
    swiperVideo() {
        new Swiper(".swiper-video", {
            observer: true,
            observeParents: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    /*******************************************************/
    /* slider del modal ver fotos en detalle departamento */
    /******************************************************/
    swiperInteriores() {
        /* genera miniaturas de la galeria */
        var thumbsInterior = new Swiper('.swpr-interThumbs', {
            spaceBetween: 23,
            slidesPerView: 2,
            freeMode: true,
            observer: true,
            observeParents: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        /* genera la galeria y sus miniaturas */
        var topInterior = new Swiper('.swpr-inter', {
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            thumbs: {
                swiper: thumbsInterior
            }
        });
    }

    /************************************************/
    /* slider de amenidades en detalle departamento */
    /************************************************/
    swiperAmenidades() {
        /* genera miniaturas de la galeria */
        var thumbsAmenidades = new Swiper('.swpr-amnddsThumbs', {
            spaceBetween: 23,
            slidesPerView: 2,
            freeMode: true,
            observer: true,
            observeParents: true,
        });
        /* genera la galeria y sus miniaturas */
        var topAmenidades = new Swiper('.swpr-amndds', {
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
              },
            thumbs: {
                swiper: thumbsAmenidades
            }
        });
    }

    swiperAmenidadesddos() {
        var thumbsAmenidades = new Swiper('.swpr-amnddsThumbs', {
            spaceBetween: 23,
            slidesPerView: 2,
            freeMode: true,
            observer: true,
            observeParents: true,
        });
        var swiper = new Swiper(".mySwiper2", {
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
        },
        
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        },
        thumbs: {
                swiper: thumbsAmenidades
            }
        });
    }

    swiperInformation() {
        var swiper = new Swiper(".mySwiper", {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 50,
              },
            },
            //autoplay: {
              //delay: 2500,
              //disableOnInteraction: false,
           // },
           navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
          });
    }


   
    
        
       
        
    /**************************************************************/
    /* Slider deptos que podrian gustarte en detalle departamento */
    /**************************************************************/
    siliderDpt() {
        new Swiper(".siliderDpt", {
            slidesPerView: 3,
            spaceBetween: 100,
            init: true,
            navigation: {
                nextEl: '.swiper-button-next-unique',
                prevEl: '.swiper-button-prev-unique',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                400: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                500: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                990: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            }
        });
    }
}

export default Slider;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/allSlider.js